exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resetPasswordText[data-v-38555eaf] {\n  text-align: center;\n  margin: 30px 0;\n  font-size: 16px;\n}\n.resetPasswordText.confirmation[data-v-38555eaf] {\n  margin: 70px 0;\n}\n.form-inputfield[data-v-38555eaf] {\n  margin-top: 50px;\n}\n.txtc[data-v-38555eaf] {\n  margin: 20px 0;\n  text-align: center;\n}\n.txtc a[data-v-38555eaf] {\n  color: #13ce67;\n}", ""]);

// exports
